import {
  ONBOARDING_REVIEWER_FAILED,
  ONBOARDING_REVIEWER_FETCHING,
  ONBOARDING_REVIEWER_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ONBOARDING_REVIEWER_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ONBOARDING_REVIEWER_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ONBOARDING_REVIEWER_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
